import { batch } from "react-redux";

import {
  AutoProfileConstants,
  Concentrate2TubesStateMapper,
} from "@/constants/autoProfileEnum";
import {
  FINAL_VOLUME,
  STARTING_CONCENTRATION,
  FINAL_CONCENTRATION,
  STARTING_VOLUME_SECOND_TUBE,
  STARTING_VOLUME_FIRST_TUBE,
} from "@/constants/fieldNames";
import {
  calcEstFinalConcentrationConcentrate2Tubes,
  calcFinalVolumeConcentrate2Tubes,
  calcTotalStartingVolConcentrate2Tubes,
  parseNumberParam,
} from "@/libs/autoProfileHelper";
import { objMapper } from "@/libs/objectHelper";

// eslint-disable-next-line import/no-cycle
import {
  bulkUpdateProfileParamByName,
  removeInvalidAutoProfileParamByName,
} from "./autoProfileBusiness";

export const changeConcentrate2TubesParam = (type, value) => (dispatch) => {
  let params = {};

  switch (type) {
    case STARTING_VOLUME_FIRST_TUBE:
      params = dispatch(setStartingLeftVol(value));
      break;
    case STARTING_VOLUME_SECOND_TUBE:
      params = dispatch(setStartingRightVol(value));
      break;
    case FINAL_VOLUME:
      params = dispatch(setFinalVol(value));
      break;
    case STARTING_CONCENTRATION:
      params = dispatch(setStartingConcVol(value));
      break;
    case FINAL_CONCENTRATION:
      params = dispatch(setEstFinalConcVol(value));
      break;

    default:
      break;
  }

  return objMapper(params, Concentrate2TubesStateMapper);
};

export const setStartingLeftVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const {
    FinalVolume,
    StartingConcentration,
    EstimatedFinalConcentration,
    StartingVolumeFor2ndTube,
  } = currentProfileParams;

  const startingVol = Number(value);
  const starting2ndVol = parseNumberParam(StartingVolumeFor2ndTube);
  const totalStartingVol = calcTotalStartingVolConcentrate2Tubes(
    startingVol,
    starting2ndVol
  );
  let finalVol = parseNumberParam(FinalVolume);
  const startingConc = parseNumberParam(StartingConcentration);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [STARTING_VOLUME_FIRST_TUBE];
  let profileParam = {
    StartingVolume: startingVol,
  };

  if (
    starting2ndVol &&
    finalVol &&
    estFinalConcentration &&
    finalVol > totalStartingVol
  ) {
    finalVol = calcFinalVolumeConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      estFinalConcentration,
      startingConc
    );
    removeInvalidParams.push(FINAL_VOLUME);
    profileParam = {
      ...profileParam,
      FinalVolume: finalVol,
    };
  }

  if (starting2ndVol && finalVol && startingConc) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setStartingRightVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const {
    StartingVolume,
    FinalVolume,
    StartingConcentration,
    EstimatedFinalConcentration,
  } = currentProfileParams;

  const startingVol = parseNumberParam(StartingVolume);
  const starting2ndVol = Number(value);
  const totalStartingVol = calcTotalStartingVolConcentrate2Tubes(
    startingVol,
    starting2ndVol
  );
  let finalVol = parseNumberParam(FinalVolume);
  let startingConc = parseNumberParam(StartingConcentration);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [STARTING_VOLUME_SECOND_TUBE];
  let profileParam = {
    StartingVolumeFor2ndTube: starting2ndVol,
  };

  if (!startingConc) {
    startingConc = AutoProfileConstants.DEFAULT_STARTING_CONC;
    removeInvalidParams.push(STARTING_CONCENTRATION);
    profileParam = {
      ...profileParam,
      StartingConcentration: startingConc,
    };
  }

  if (
    startingVol &&
    finalVol &&
    estFinalConcentration &&
    finalVol > totalStartingVol
  ) {
    finalVol = calcFinalVolumeConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      estFinalConcentration,
      startingConc
    );
    removeInvalidParams.push(FINAL_VOLUME);
    profileParam = {
      ...profileParam,
      FinalVolume: finalVol,
    };
  }

  if (startingVol && finalVol && startingConc) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setFinalVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const {
    StartingVolume,
    StartingVolumeFor2ndTube,
    StartingConcentration,
    EstimatedFinalConcentration,
  } = currentProfileParams;

  const finalVol = Number(value);

  const startingVol = parseNumberParam(StartingVolume);
  const starting2ndVol = parseNumberParam(StartingVolumeFor2ndTube);
  const startingConc = parseNumberParam(StartingConcentration);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [FINAL_VOLUME];
  let profileParam = {
    FinalVolume: finalVol,
  };

  if (startingVol && starting2ndVol && startingConc) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setStartingConcVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const {
    StartingVolume,
    StartingVolumeFor2ndTube,
    FinalVolume,
    EstimatedFinalConcentration,
  } = currentProfileParams;

  const finalVol = parseNumberParam(FinalVolume);
  const startingVol = parseNumberParam(StartingVolume);
  const starting2ndVol = parseNumberParam(StartingVolumeFor2ndTube);
  const startingConc = Number(value);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [STARTING_CONCENTRATION];
  let profileParam = {
    StartingConcentration: startingConc,
  };

  if (startingVol && starting2ndVol && finalVol) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setEstFinalConcVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const {
    StartingVolume,
    StartingVolumeFor2ndTube,
    FinalVolume,
    StartingConcentration,
  } = currentProfileParams;

  let finalVol = parseNumberParam(FinalVolume);
  const startingVol = parseNumberParam(StartingVolume);
  const startingConc = parseNumberParam(StartingConcentration);
  const starting2ndVol = parseNumberParam(StartingVolumeFor2ndTube);
  const estFinalConcentration = Number(value);

  const removeInvalidParams = [FINAL_CONCENTRATION];
  let profileParam = {
    EstimatedFinalConcentration: estFinalConcentration,
  };

  if (startingVol && starting2ndVol && startingConc) {
    finalVol = calcFinalVolumeConcentrate2Tubes(
      startingVol,
      starting2ndVol,
      estFinalConcentration,
      startingConc
    );
    removeInvalidParams.push(FINAL_VOLUME);
    profileParam = {
      ...profileParam,
      FinalVolume: finalVol,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};
